import React, { useRef } from "react";
import CameraIcon from "@mui/icons-material/Camera";
import AntLogo from "../../Header/img/Ant.png";
import PopoverInfo from "./PopoverInfo";
import { useSelector } from "react-redux";

const BasicDetails = ({
  handleChange,
  values,
  errors,
  touched,
  setFieldTouched,
  setFieldValue,
  isEnglish,
  setIsEnglish
}) => {
  const fileInputRef = useRef();
  const user = useSelector((state) => state.AuthReducer.user);

  const t = {
    infoBanner: isEnglish? [
      "⏰ Submit in 72 h or the form resets.",
      "💸 Judges earn 🎟️ 20% of prize pool (₹1,000–5,000 / contest) | 🗓️ ₹10,000–25,000 / month",
      "🔒 Secured by Razorpay • 🏅 Trusted by 150+ judges • ✍️ 1, 688 contributors and counting"
    ]: [
      "⏰ 72 घंटे में सबमिट करें, नहीं तो फॉर्म रीसेट हो जाएगा।",
      "💸 जज कमाते हैं 🎟️ पुरस्कार पूल का 20% (₹1,000–5,000/प्रतियोगिता) | 🗓️ ₹10,000–25,000/महीना",
      "🔒 Razorpay द्वारा सुरक्षित • 🏅 150+ जजों द्वारा विश्वसनीय • ✍️ 1,688 योगदानकर्ता और गिनती जारी"
    ],

    firstName: isEnglish ? "First Name*" : "पहला नाम*",
    firstNamePlaceholder: isEnglish ? "Enter First Name" : "पहला नाम दर्ज करें",

    lastName: isEnglish ? "Last Name*" : "अंतिम नाम*",
    lastNamePlaceholder: isEnglish ? "Enter Last Name" : "अंतिम नाम दर्ज करें",

    email: isEnglish ? "Email*" : "ईमेल*",
    emailPlaceholder: isEnglish ? "Enter Your Email" : "अपना ईमेल पता दर्ज करें",

    contact: isEnglish ? "Contact Number*" : "संपर्क नंबर*",
    contactPlaceholder: isEnglish
      ? "Enter Your Contact Number"
      : "अपना संपर्क नंबर दर्ज करें",
    contactInfo: isEnglish
      ? "Our team will reach out to you for confirmation after you complete the form."
      : "हमारी टीम फॉर्म पूरा करने के बाद आपसे संपर्क करेगी।",

    upi: isEnglish ? "UPI*" : "यूपीआई*",
    upiPlaceholder: isEnglish
      ? "Enter Your UPI ID"
      : "अपना यूपीआई आईडी दर्ज करें",
    upiInfo: isEnglish
      ? "Please enter your UPI ID to receive your judgment fees."
      : "कृपया अपना यूपीआई आईडी दर्ज करें ताकि आपको जजमेंट फीस प्राप्त हो सके।",
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFieldValue("profilePicture", file);
    }
  };

  const triggerFileSelect = () => {
    fileInputRef.current?.click();
  };

  const getPreviewUrl = () => {
    if (values.profilePicture instanceof File) {
      return URL.createObjectURL(values.profilePicture);
    } else if(values.profilePicture && typeof values.profilePicture === "string") {
      return values.profilePicture;
    }
    return AntLogo;
  };

  const inputBaseClass = `w-full border border-gray-300 rounded-lg px-3 py-2 text-sm text-[#0D1C2E] font-[Gilroy-Regular] focus:outline-none focus:ring focus:ring-blue-200`;

  return (
    <div className="w-full">
      <ul className="py-4 px-6 rounded-xl flex flex-col gap-2 text-[#D2D2D2] text-sm font-medium bg-[#008080] list-disc my-3 md:mt-1">
        <li>
          {t.infoBanner[0]}
        </li>
        <li>
          {t.infoBanner[1]}
        </li>
        <li>{t.infoBanner[2]}</li>
      </ul>


      {/* Profile Section */}
      <div className="flex items-center justify-center relative flex-col">
        <div className="relative w-24 h-24">
          <img
            src={getPreviewUrl()}
            alt="Profile"
            className="object-cover w-full h-full rounded-full overflow-hidden border border-gray-300 bg-gray-100"
          />

          {/* Camera Button */}
          <button
            onClick={triggerFileSelect}
            className="absolute -bottom-2 -right-2 bg-white border-2 border-white rounded-full p-2 shadow-md"
            type="button">
            <CameraIcon className="w-5 h-5 text-gray-600" />
          </button>
        </div>

        {/* Hidden File Input */}
        <input
          type="file"
          accept="image/png, image/jpeg, image/jpg"
          ref={fileInputRef}
          onChange={handleFileChange}
          className="hidden"
        />
        {touched.profilePicture && errors.profilePicture && (
          <p className="text-sm text-red-500 mt-1">{errors.profilePicture}</p>
        )}
        <div className="absolute top-0 right-0 flex justify-end">
          {/* Toogle Button */}
          <div
            className="relative w-20 h-8 ps-2 pe-1.5 flex items-center justify-between rounded-full bg-[#D9D9D9] cursor-pointer"
            onClick={() => setIsEnglish((prev) => !prev)}>
            <div
              className={`absolute w-10 h-8 rounded-full bg-[#008080] shadow-md transition-all duration-500 ${
                isEnglish ? "left-0" : "right-0"
              }`}
            />

            <p
              className={`z-10 font-semibold text-xs transition-colors ${!isEnglish ? "text-black" : "text-white"}`}>
              ENG
            </p>
            <p
              className={`z-10 font-semibold text-xs transition-colors ${isEnglish ? "text-black" : "text-white"} pt-[2px]`}>
              हिन्दी
            </p>
          </div>
        </div>
      </div>

      {/* First Name */}
      <div className="pt-4 mb-2">
        <label className="text-base font-gilroy-medium text-[#0D1C2E] tracking-tight">
          {t.firstName}
        </label>
        <input
          maxLength={40}
          onChange={handleChange("firstName")}
          onBlur={() => setFieldTouched("firstName")}
          value={values.firstName}
          placeholder={t.firstNamePlaceholder}
          className={inputBaseClass}
        />
        {touched.firstName && errors.firstName && (
          <p className="text-sm text-red-500 mt-1">{errors.firstName}</p>
        )}
      </div>

      {/* Last Name */}
      <div className="pt-1 mb-2">
        <label className="text-base font-gilroy-medium text-[#0D1C2E] tracking-tight">
          {t.lastName}
        </label>
        <input
          maxLength={40}
          onChange={handleChange("lastName")}
          onBlur={() => setFieldTouched("lastName")}
          value={values.lastName}
          placeholder={t.lastNamePlaceholder}
          className={inputBaseClass}
        />
        {touched.lastName && errors.lastName && (
          <p className="text-sm text-red-500 mt-1">{errors.lastName}</p>
        )}
      </div>

      {/* Email */}
      <div className="pt-1 mb-2">
        <label className="text-base font-gilroy-medium text-[#0D1C2E] tracking-tight">
          {t.email}
        </label>
        <input
          value={values.email}
          disabled={user}
          onChange={handleChange("email")}
          onBlur={() => setFieldTouched("email")}
          placeholder={t.emailPlaceholder}
          className={inputBaseClass}
        />
        {touched.email && errors.email && (
          <p className="text-sm text-red-500 mt-1">{errors.email}</p>
        )}
      </div>

      {/* Contact Number */}
      <div className="pt-1 mb-2">
        <div className="flex items-center gap-2">
          <label className="text-base font-gilroy-medium text-[#0D1C2E] tracking-tight">
            {t.contact}
          </label>
          <PopoverInfo infoText={t.contactInfo} />
        </div>
        <input
          type="number"
          onChange={handleChange("contactNumber")}
          onBlur={() => setFieldTouched("contactNumber")}
          value={values.contactNumber}
          placeholder={t.contactPlaceholder}
          className={inputBaseClass}
        />
        {touched.contactNumber && errors.contactNumber && (
          <p className="text-sm text-red-500 mt-1">{errors.contactNumber}</p>
        )}
      </div>

      {/* UPI */}
      <div className="pt-1 mb-2">
        <div className="flex items-center gap-2">
          <label className="text-base font-gilroy-medium text-[#0D1C2E] tracking-tight">
            {t.upi}
          </label>
        </div>
        <div className="relative">
          <input
            value={values.upi}
            onChange={handleChange("upi")}
            onBlur={() => setFieldTouched("upi")}
            placeholder={t.upiPlaceholder}
            className={inputBaseClass}
          />
          <div className="absolute right-0 top-1/2 -translate-y-1/2 py-1 px-2" >
            <PopoverInfo infoText={t.upiInfo} />
          </div>
        </div>
        {touched.upi && errors.upi && (
          <p className="text-sm text-red-500 mt-1">{errors.upi}</p>
        )}
      </div>
    </div>
  );
};

export default BasicDetails;
